// src/components/NewVisit

// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ErrorAlert, PageLoadingSpinner } from 'ui_kit_qmd'
import { useLocation, useNavigate } from 'react-router-dom'
import './NewVisit.scss'
import _ from 'lodash'

import { useAutoUpdatingRef } from '@quickmd-llc/frontend-utils'
import { useGetPatientsPatientIdVisitTypesVisitTypeId } from '@/api/generated/patient/patient'
import { readVisitPrice, resolveDefaultVisitPrice } from '@/utils/program'
import { useServiceTypes } from '@/hooks/useServiceTypes'
import errorIcon from '../../images/common/error-icon.svg'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import { AVAILABILITY_LABEL, AVAILABILITY_ROUTE, RESCHEDULE_VISIT_PAGE_PATH } from '../../utils/constants'
import { styles, text } from './Constants'
import { NewVisitHeader } from './components/new-visit-header/NewVisitHeader'
import { PatientInformation } from './components/patient-information/PatientInformation'
import { deleteBooking, setError } from '../../store/new-visit/NewVisitActions'
import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import { VisitInformation } from './components/visit-information/VisitInformation'
import { statesOptions } from '../../utils/common'
import { ReviewBook } from './components/review-book/ReviewBook'
import { NewVisitListener } from '../../store/new-visit/NewVisitListener'
import { usePatientSearch } from './hooks/usePatientSearch'

// Custom Hooks
import { useProviderInfo } from './hooks/useProviderInfo'
import { useTimeZone } from './hooks/useTimeZone'
import { usePaymentKeys } from './hooks/usePaymentKeys'
import { useBreadcrumbs } from './hooks/useBreadcrumbs'
import { usePrimaryClick } from './hooks/usePrimaryClick'
import { useSecondaryClick } from './hooks/useSecondaryClick'
import { useInitializeVisitTypes } from './hooks/useInitializeVisitTypes'
import { usePopulateServiceVisitData } from './hooks/usePopulateServiceVisitData'
import { useHandleCardsAndReviewBook } from './hooks/useHandleCardsAndReviewBook'
import { useReschedulePrimaryClick } from './hooks/useReschedulePrimaryClick'
import { getSettingsPerState } from '../../store/management/ManagementThunk'
import { useVisitMethods } from './hooks/useVisitMethods'

// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
const pageContainerStyle = {
  overflow: 'hidden',
}

export const NewVisit = () => {
  const { pathname, state: routeState } = useLocation()
  const state = routeState ?? {}
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const isReschedulePage = pathname === RESCHEDULE_VISIT_PAGE_PATH

  // References
  const bookingId = useRef(state?.bookingId || '0')
  const useDefaultTime = useRef(state?.useDateTime)
  const reviewBookingRef = useRef()

  // Custom Hooks Integration
  const provider = useProviderInfo(state?.provider?.providerId, bookingId.current)
  const { currentTimeZone, zoneAbbr, zoneAbbrString } = useTimeZone(state?.customTimeZone)
  usePaymentKeys()

  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const paymentKeys = useSelector((state) => state.newVisitReducer.paymentKeys)

  // Use the new breadcrumbs hook
  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  const breadCrumbs = useBreadcrumbs(state)

  // Selectors
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const error = useSelector((state) => state.newVisitReducer.visits[bookingId.current]?.error || '')
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const loading = useSelector((state) => state.newVisitReducer.visits[bookingId.current]?.loading)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const loggedIn = useSelector((state) => state.auth.loggedIn)
  const cards = useSelector(
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    (state) => state?.newVisitReducer.visits[bookingId.current]?.cards,
    (a, b) => _.isEqual(a, b),
  )
  const { serviceTypes } = useServiceTypes()
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const statesSettings = useSelector((state) => state.management.statesSettings)

  // Local State
  const [showReviewBook, setShowReviewBook] = useState(false)
  const [visitOptions, setVisitOptions] = useState({})
  const [forcePaymentLoading, setForcePaymentLoading] = useState(false)
  const [selectedVisit, setSelectedVisit] = useState(null)
  const [visitTypes, setVisitTypes] = useState({})

  const [providerServiceVisitTypes, setProviderServiceVisitTypes] = useState([])
  const [providerServiceVisitNames, setProviderServiceVisitNames] = useState([])
  const [states, setStates] = useState(null)
  const [price, setPrice] = useState(0)
  const [priceError, setPriceError] = useState('')
  const [methodCardError, setMethodCardError] = useState('')
  const [dateError, setDateError] = useState('')
  const [timeError, setTimeError] = useState('')
  const [visitError, setVisitError] = useState('')
  const [methodError, setMethodError] = useState('')
  const [stateError, setStateError] = useState('')
  const [cardMethod, setCardMethod] = useState(null)
  const [mounted, setMounted] = useState(false)
  const [originalVisitDateTime, setOriginalVisitDateTime] = useState(null)

  const { methods: dynamicMethods, isMethodsLoading } = useVisitMethods(
    selectedVisit,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    visitOptions.state,
    statesSettings.SettingsPerState,
  )

  const {
    forceSearchLoading,
    showSearchResults,
    searchResults,
    selectedPatient,
    fullNameError,
    onSearchChanged,
    onPatientSelected,
    onSetShowResults,
    setFullNameError,
    // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
  } = usePatientSearch(bookingId, navigate)

  const { data: visitTypeData } = useGetPatientsPatientIdVisitTypesVisitTypeId(
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    selectedPatient?.PatientId,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    selectedVisit?.VisitTypeId,
    {
      query: {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        enabled: Boolean(selectedPatient?.PatientId && selectedVisit?.VisitTypeId),
      },
    },
  )

  // The backend quotes what this visit will actually cost — zero when a package the
  // patient already owns covers this visit type — so a program patient's visit
  // defaults to the covered price rather than the base service price. Read off the
  // response defensively because the contract CI generates against does not yet
  // carry `Price`; falls back to the base price when there is no quote.
  const quotedVisitPrice = readVisitPrice(visitTypeData)
  const baseVisitPrice = readVisitPrice(selectedVisit)
  const defaultVisitPrice = resolveDefaultVisitPrice(quotedVisitPrice, baseVisitPrice)

  // The state-selection effect below also writes `price`, and it re-runs whenever the
  // patient or the visit-option list changes identity — long after the quote has landed.
  // It reads the default through this ref so it re-asserts the covered price instead of
  // the base one, and so a quote arriving later cannot re-trigger that effect's other work.
  const defaultVisitPriceRef = useAutoUpdatingRef(defaultVisitPrice)

  // Keep the charged price in step with the quoted default until the admin reaches the
  // payment step (where they can edit it). The quote resolves asynchronously, so without
  // this a booking committed while it was still loading would charge the base price even
  // though the summary later shows the covered $0. Once the review step is shown, the
  // PaymentInfo field owns the price and pushes edits back through `setPrice`.
  useEffect(() => {
    if (!showReviewBook && typeof defaultVisitPrice === 'number') {
      setPrice(defaultVisitPrice)
    }
  }, [defaultVisitPrice, showReviewBook])

  const handlePrimaryClick = usePrimaryClick({
    showReviewBook,
    selectedVisit,
    visitOptions,
    selectedPatient,
    dispatch,
    cardMethod,
    price,
    patientVisitCredit: visitTypeData?.CreditAmount,
    isCoveredByPackage: Boolean(visitTypeData?.Coverage),
    state,
    currentTimeZone,
    // @ts-expect-error TS2353 -- MIGRATION: not approved, fix when encountered
    navigate,
    setPriceError,
    setMethodCardError,
    setTimeError,
    setDateError,
    setVisitError,
    setMethodError,
    setStateError,
    setFullNameError,
  })

  const reschedulePrimaryClick = useReschedulePrimaryClick({
    showReviewBook,
    setShowReviewBook,
    visitOptions,
    // @ts-expect-error TS2353 -- MIGRATION: not approved, fix when encountered
    setTimeError,
    setDateError,
    dispatch,
    state,
    currentTimeZone,
    originalVisitDateTime,
  })

  const handleSecondaryClick = useSecondaryClick({
    showReviewBook,
    state,
    bookingId,
    dispatch,
    navigate,
    setShowReviewBook,
  })

  const onAddCardSuccess = useCallback(() => {
    setForcePaymentLoading(false)
    if (methodCardError) setMethodCardError('')
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    reviewBookingRef?.current?.onAddCardSuccess()
  }, [methodCardError])

  const onBookVisitSuccess = useCallback(() => {
    dispatch(deleteBooking(bookingId.current))
    navigate(-1)
  }, [dispatch, navigate])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onForceLoading = useCallback((value) => {
    setForcePaymentLoading(value)
  }, [])

  const onSetPrice = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      if (priceError) setPriceError('')
      setPrice(value)
    },
    [priceError],
  )

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onSetCardMethod = useCallback((value) => {
    setCardMethod(value)
  }, [])

  // Restore the onSetVisitOptions function
  const onSetVisitOptions = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (options) => {
      const selectedOptions = { ...visitOptions, ...options }
      switch (selectedOptions.updateType) {
        case 'serviceVisitName':
          const selectedVisits = providerServiceVisitTypes
            .map((serviceVisit) => {
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              if (serviceVisit.ServiceVisitName === selectedOptions.serviceVisitName) {
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                selectedOptions.visitType = serviceVisit.Name
                return serviceVisit
              }
            })
            .filter((value) => value !== undefined)
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          setSelectedVisit(selectedVisits[0])
          selectedOptions.selectedVisits = selectedVisits
          if (visitError) setVisitError('')
          break
        case 'method':
          if (methodError) setMethodError('')
          break
        case 'state':
          if (stateError) setStateError('')
          break
        case 'date':
          if (timeError === getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, text.TIME)) {
            if (selectedOptions.time) {
              setTimeError('')
            }
          } else if (timeError) setTimeError('')
          if (dateError) setDateError('')
          break
        default:
      }

      setVisitOptions((prev) => ({ ...prev, ...selectedOptions }))
    },
    [visitOptions, providerServiceVisitTypes, visitError, methodError, stateError, timeError, dateError],
  )

  useEffect(() => {
    if (!originalVisitDateTime) {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      setOriginalVisitDateTime(visitOptions.date)
    }
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  }, [visitOptions.date])

  useEffect(() => {
    if (!statesSettings?.SettingsPerState || statesSettings.SettingsPerState.length === 0) {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(getSettingsPerState())
    }
  }, [dispatch, statesSettings])

  useInitializeVisitTypes(serviceTypes, setVisitTypes)
  usePopulateServiceVisitData(
    serviceTypes,
    provider,
    visitTypes,
    setProviderServiceVisitTypes,
    setProviderServiceVisitNames,
  )
  useHandleCardsAndReviewBook(cards, mounted, setMounted, setShowReviewBook)

  // Effect: Handle Errors
  useEffect(() => {
    if (error) {
      setForcePaymentLoading(false)
      const timeout = setTimeout(() => {
        dispatch(setError('', bookingId.current))
        if (
          error === getUserFriendlyErrorMessage(errorCodes.DOES_NOT_EXIST_NO_REFRESH, null, text.PROVIDER) ||
          error === getUserFriendlyErrorMessage(errorCodes.CANNOT_BOOK_VISIT)
        ) {
          navigate(AVAILABILITY_ROUTE, { replace: true })
        }
      }, 3500)
      return () => clearTimeout(timeout)
    }
  }, [dispatch, error, navigate])

  useEffect(() => {
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    if (selectedVisit && visitOptions.selectedVisits) {
      if (stateError) setStateError('')

      const nextPrice = defaultVisitPriceRef.current
      if (typeof nextPrice === 'number') setPrice(nextPrice)

      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const foundStates = visitOptions.selectedVisits
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        .map((visit) => {
          let stateOption

          // Special handling for 'VI' and 'PR'
          if (visit.StateCode.toUpperCase() === 'VI') {
            stateOption = 'Virgin Islands VI'
          } else if (visit.StateCode.toUpperCase() === 'PR') {
            stateOption = 'Puerto Rico PR'
          } else {
            // Existing logic to find the state option
            stateOption = statesOptions.find((stateOption) => {
              // @ts-expect-error TS2532 -- MIGRATION: not approved, fix when encountered
              const stateCode = stateOption.split(' ').pop().toUpperCase()
              return stateCode === visit.StateCode.toUpperCase()
            })
          }

          return stateOption ? { stateCode: visit.StateCode, stateOption } : null
        })
        .filter(Boolean) // Filter out any null or undefined values

      // Updated condition
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (selectedPatient && selectedVisit.IsLocationMatchRequired) {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        const patientStateCode = selectedPatient.Address.StateCode.toUpperCase()
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        const filteredStates = foundStates.filter((item) => item.stateCode.toUpperCase() === patientStateCode)

        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        setStates(filteredStates.map((item) => item.stateOption))
      } else {
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        const uniqueStates = [...new Set(foundStates.map((item) => item.stateOption))]
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        setStates(uniqueStates.sort((a, b) => a.localeCompare(b)))
      }
    }
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  }, [selectedVisit, visitOptions.selectedVisits, selectedPatient, defaultVisitPriceRef])

  return (
    <>
      {forceSearchLoading || loading || forcePaymentLoading || isMethodsLoading || !loggedIn ?
        <PageLoadingSpinner />
      : null}
      {error && loggedIn ?
        <ErrorAlert
          styleContainer={styles.ERROR_STYLE}
          errorText={error}
          errorImg={errorIcon}
          imgAlt='Error'
          iconStyle={styles.ERROR_ICON_STYLE}
        />
      : null}

      <NewVisitListener
        bookingId={bookingId.current}
        addCardSuccess={onAddCardSuccess}
        bookVisitSuccess={onBookVisitSuccess}
      />

      <div className='new-visit-container'>
        {/*
         // @ts-expect-error TS2741 -- MIGRATION: not approved, fix when encountered */}
        <NewVisitHeader
          primaryClick={isReschedulePage ? reschedulePrimaryClick : handlePrimaryClick} // Correct: Click handler
          secondaryClick={handleSecondaryClick} // Correct: Click handler
          isReviewBook={showReviewBook}
        />

        {/*
         // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered */}
        <div className='new-visit-body-container' style={showReviewBook ? styles.OFF_SCREEN : null}>
          {/*
           // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered */}
          <PatientInformation
            searchChanged={onSearchChanged}
            searchResults={showSearchResults ? searchResults : null}
            patientSelected={onPatientSelected}
            setIsSearchActive={onSetShowResults}
            fullNameError={fullNameError}
            show={!showReviewBook}
          />
          {/*
           // @ts-expect-error TS2741 -- MIGRATION: not approved, fix when encountered */}
          <VisitInformation
            provider={provider || state?.provider || {}}
            defaultDateTime={state?.clickedDateTime}
            serviceVisitNames={providerServiceVisitNames}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            isInPerson={selectedVisit?.IsInPerson}
            methods={dynamicMethods}
            isMethodsLoading={isMethodsLoading}
            states={states}
            setVisitOptions={onSetVisitOptions}
            dateError={dateError}
            timeError={timeError}
            stateError={stateError}
            methodError={methodError}
            visitError={visitError}
            zoneAbbr={zoneAbbr.current}
            zoneAbbrString={zoneAbbrString}
            timeZone={state?.customTimeZone || currentTimeZone}
            show={!showReviewBook}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            patientState={selectedPatient?.Address?.StateCode}
            useDefaultTime={useDefaultTime.current}
            providerServiceVisitTypes={providerServiceVisitTypes}
            providerId={state?.provider?.providerId}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            patientId={selectedPatient?.PatientId}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            visitTypeId={selectedVisit?.VisitTypeId}
          />
        </div>
        {/*
         // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered */}
        <div className='new-visit-review-body-container' style={!showReviewBook ? styles.OFF_SCREEN : null}>
          <ReviewBook
            ref={reviewBookingRef}
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            bookingId={bookingId.current}
            visitInfo={{ ...visitOptions, price: defaultVisitPrice }}
            selectedPatient={selectedPatient}
            creditAmount={visitTypeData?.CreditAmount}
            show={showReviewBook}
            zoneAbbrString={zoneAbbrString}
            timeZone={state?.customTimeZone}
            paymentKeys={paymentKeys}
            forceLoading={onForceLoading}
            setPrice={onSetPrice}
            methodError={methodCardError}
            priceError={priceError}
            setCardMethod={onSetCardMethod}
            setMethodCardError={setMethodCardError}
            onBookVisitSuccess={onBookVisitSuccess}
          />
        </div>
      </div>
    </>
  )
}
